import { InstagramInfluencerV3, SocialAccountType } from '@anytag/graphql';
import { InstagramInfluencerProfile } from './schemaTypes';

export const formatInfluencerProfile = (infl: InstagramInfluencerV3): InstagramInfluencerProfile => ({
  id: infl.id,
  age: infl.age,
  name: infl.name,
  gender: infl.gender,
  avatar: infl.avatar,
  country: infl.country,
  averageLikes: infl.averageLikes,
  averageReach: infl.averageReach,
  isBrandAccount: infl.isBrandAccount,
  socialAccountId: infl.socialAccountId,
  analyticsWarning: infl.analyticsWarning,
  socialAccountStatus: infl.socialAccountStatus,
  socialAccountType: SocialAccountType.INSTAGRAM,
  socialAccountFollowers: infl.socialAccountFollowers,
  socialAccountEngagementRate: infl.socialAccountEngagementRate,
  posts:
    infl.popularPosts?.map(({ postId, thumbNail, type, caption }) => ({
      type,
      caption,
      thumbNail,
      id: postId,
      influencerId: Number(infl.id)
    })) || []
});
